export const GET_DASHBOARD_STATS_ACTIONS = {
    GET_DASHBOARD_STATS_STARTED: "GET_DASHBOARD_STATS_STARTED",
    GET_DASHBOARD_STATS_INVALID_JSON: "GET_DASHBOARD_STATS_INVALID_JSON",
    GET_DASHBOARD_STATS_INVALID_RESPONSE: "GET_DASHBOARD_STATS_INVALID_RESPONSE",
    GET_DASHBOARD_STATS_OK: "GET_DASHBOARD_STATS_OK",

}
